import { useNavigate } from 'react-router-dom';
import PawPrint from './PawPrint';

const Logo = ({ className = '', dark = false, size = 'md', onClick }) => {
  const navigate = useNavigate();
  
  const textClass = size === 'lg' ? 'text-3xl' : size === 'md' ? 'text-2xl' : 'text-lg';
  const iconSize  = size === 'lg' ? 'w-10 h-10' : size === 'md' ? 'w-8 h-8' : 'w-7 h-7';
  const textColor = dark ? 'text-white' : 'text-[#064E3B]';

  const handleClick = (e) => {
    if (onClick) {
      onClick(e);
    } else {
      navigate('/');
    }
  };

  return (
    <div 
      onClick={handleClick} 
      className={`flex items-center gap-2 cursor-pointer hover:opacity-90 transition-opacity select-none ${className}`}
    >
      <PawPrint className={iconSize} color="#BFDB38" />
      <span 
        className={`${textClass} font-black ${textColor} tracking-tight`}
        style={{ fontFamily: "'Inter', system-ui, sans-serif", letterSpacing: '-0.5px' }}
      >
        PurrCheck
      </span>
    </div>
  );
};

export default Logo;
